import ComponentWrapper from '../../fragments/component-wrapper/ComponentWrapper';

import { motion } from 'motion/react';

export default function HeroCopy({ block, index }) {
  if (!block) return null;

  return (
    <ComponentWrapper className="BlockHeroCopy">
      <div className="l-grid">
        <motion.div
          className={`l-grid__col text--size-xl`}
          // Not RichText (it's a motion.div), so it opts into flow margins
          // directly. Keep the attribute if this moves.
          data-flow="content"
          dangerouslySetInnerHTML={{ __html: block.content }}
          initial={{ opacity: 0, y: '10px' }}
          animate={{ opacity: 1, y: '0px' }}
          transition={{ type: 'spring', duration: 0.7, delay: 0.9 }}
        ></motion.div>
      </div>
    </ComponentWrapper>
  );
}
